"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiSnackbar = getMuiSnackbar;
function getMuiSnackbar(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required'
    },
    styleOverrides: {
      root: {
        '.MuiAlert-root': {
          '.MuiAlert-action': {
            paddingTop: 0
          },
          padding: '0 34px'
        }
      }
    }
  };
}